var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 134,
    viewBox: "0 0 152 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 133.61,
    id: "filter0_d_22_7431",
    width: 151.6,
    x: 0.2,
    y: 0.02
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22_7431"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 78.88,
    id: "filter1_d_22_7431",
    width: 109.99,
    x: 31.61,
    y: 27.3
  }, /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22_7431"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22_7431)",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.01,
    cy: 62.82,
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_2",
    r: 49.61,
    stroke: "#378F0E",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_22_7431)",
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m134.72,27.3c2.53,0 3.82,2.99 2.07,4.79l-31.79,32.46l-0.92,0.96l-12.35,12.61l-3.91,3.97l-14.9,15.22c-0.54,0.56 -1.29,0.87 -2.07,0.87l-10.77,0c-1.18,0 -2.25,-0.71 -2.68,-1.79l-10.69,-26.67l-1.42,-3.57l0,-0.02l-8.51,-21.19l0,-0.02l-0.96,-2.41c-0.75,-1.86 0.64,-3.86 2.67,-3.86l14.77,0c1.23,0 2.33,0.78 2.73,1.94l8.98,26.54l2.27,6.75c0.75,2.21 3.71,2.64 5.07,0.75l15.51,-21.57l6.51,-9.03l11.16,-15.53c0.54,-0.75 1.42,-1.19 2.34,-1.19l26.89,0l0,-0.01z",
    fill: "#378F0E",
    id: "svg_4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5e0a09a0cf06b33c9303d4ec846c0583.svg";
export { ForwardRef as ReactComponent };